import script from "./CardView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__